export const messages = Object.freeze({
    could_not_delete_video: 'Could not delete video. Please try again or contact support.',
    could_not_edit_video: 'Could not edit video. Please try again or contact support.',
    could_not_get_quota: 'Could not get quota. Please try again or contact support.',
    could_not_get_videos: 'Could not get videos. Please try again or contact support.',
    could_not_move_video: 'Could not move video. Please try again or contact support.',
    could_not_whitelist_domain: 'Could not whitelist domain. Please try again or contact support.',
    no_fids_provided: 'No videos were selected for upload.',
    not_video: 'The selected file is not a video.',
    org_folder_creation_unsuccessful: 'The organization folder could not be created. Please contact support.',
    org_folder_does_not_exist: 'The requested organization folder could not be found.',
    space_folder_creation_unsuccessful: 'The space folder could not be created. Please contact support.',
    space_folder_does_not_exist: 'The requested space folder could not be found.',
    video_duration_limit_reached: 'The video duration limit has been reached.',
    video_not_in_space: 'Videos must be in the same space.',
    videos_from_multiple_instances: 'Please select videos to upload from a single instance.'
})

export const dialogs = Object.freeze({})
